import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchSampleType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getLabDeptlist } from "../../../redux/action/lab_dept_action";

const SampleTypeDropdownNew = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
}) => {
  const dispatch = useDispatch();
  const selectedLabDepartment = watch("sample_type_id");

  const sampleTypeList = rowData
    ? rowData?.sample_type_obj
    : getValues().sample_type_obj;

  useEffect(() => {
    if (rowData) {
      const modifiedObj = rowData?.sample_type_obj.map((ele) => ({
        value: ele.id,
        label: ele.sample_type,
      }));
      setValue("sample_type_obj", modifiedObj);
      setValue("default_sample_id", rowData.default_sample_id);
    } else if (getValues()) {
      setValue("sample_type_obj", getValues().sample_type_obj);
    }
  }, [rowData, getValues, setValue]);

  const {
    data: sampleTypes,
    isLoading,
    error,
  } = useQuery(["Sample Types"], () => fetchSampleType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });
  const modifiedData = useMemo(() => {
    if (sampleTypes?.data?.data) {
      return sampleTypes.data.data.map((ele) => ({
        ...ele,
        sample_type_id: ele.id,
      }));
    }
    return [];
  }, [sampleTypes]);

  const options = useMemo(() => {
    return modifiedData.map((sampleType) => ({
      value: sampleType.sample_type_id,
      label: sampleType.sample_type,
    }));
  }, [modifiedData]);

  // const selectedOption = useMemo(() => {
  //   return options.filter((option) => {
  //     return sampleTypeList.some((sample) => {
  //       return sample.sample_type === option.label;
  //     });
  //   });
  // }, [options, sampleTypeList]);

  // useEffect(() => {
  //   if (selectedOption) {
  //     setValue("sample_type_id", selectedOption.map((ele) => ele.value));
  //     setValue("sample_type_obj", selectedOption);
  //   }
  // }, [selectedOption, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Lab Departments</div>;

  return (
    <Controller
      name="sample_type_obj"
      control={control}
      rules={{ required: "Sample Type Object is required" }}
      render={({ field }) => {
        return (
          <Select
            {...field}
            isMulti
            options={options}
            closeMenuOnSelect={false}
            isClearable
            value={field.value || []}
            placeholder="Select Sample Types"
            menuPortalTarget={document.body}
            // defaultValue={selectedOption}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            onChange={(selectedOption) => {
              const selectedValue = selectedOption.map((ele) => ({
                value: ele.value,
                label: ele.label,
              }));
              const value = selectedOption
                ? selectedOption.map((ele) => ele.value)
                : [];
              field.onChange(selectedOption);
              setValue("sample_type_id", value);
              setValue("sample_type_obj", selectedOption);
            }}
            className={`react-select-container ${
              errors.sample_type_id ? "is-invalid" : ""
            }`}
          />
        );
      }}
    />
  );
};

export default SampleTypeDropdownNew;
